import React from 'react';
import { ThemeProvider } from './ThemeContext';
import { LanguageProvider } from './LanguageContext';
import { AuthProvider } from './AuthContext';
import { SelectedAccountProvider } from './SelectedAccountContext';
import { ThreadsInsightsProvider } from './ThreadsInsightsContext';
import { ChatHistoryProvider } from './ChatHistoryContext';
import { ToastProvider } from '../components/ui/Toast/Toast';

/**
 * 所有 Context Providers 的組合
 * 簡化 App.js 的巢狀結構
 */
function AppProviders({ children }) {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <SelectedAccountProvider>
            <ThreadsInsightsProvider>
              <ChatHistoryProvider>
                <ToastProvider>
                  {children}
                </ToastProvider>
              </ChatHistoryProvider>
            </ThreadsInsightsProvider>
          </SelectedAccountProvider>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default AppProviders;
